export const STRIPE_BILLING_URL = 'https://billing.stripe.com/p/login/test_14kcNs3lsbHl9I4eUU';

export const LINKS = {
  IMAGE_GUIDE: 'https://foodla.nu/en/foodla-faq-fota-en-produktbild/',
};

export enum PRODUCT_TABS {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  DISAPPROVED = 'DISAPPROVED',
}

export const SUPERUSER_APPROVAL = {
  ADMIN_APPROVED: 'ADMIN_APPROVED',
  AWAITING_APPROVAL: 'AWAITING_APPROVAL',
  ADMIN_DISAPPROVED: 'ADMIN_DISAPPROVED',
};

export const SUPERUSER_APPROVAL_LABEL: Record<string, string> = {
  [SUPERUSER_APPROVAL.ADMIN_APPROVED]: 'Approved',
  [SUPERUSER_APPROVAL.AWAITING_APPROVAL]: 'Under Review',
  [SUPERUSER_APPROVAL.ADMIN_DISAPPROVED]: 'Failed Review',
};

export const ADMIN_SUBSCRIPTION_STATUS_LABELS: Record<string, string> = {
  [PRODUCT_TABS.PENDING]: 'Ready to subscribe',
  [PRODUCT_TABS.APPROVED]: 'Subscribed',
  [PRODUCT_TABS.DISAPPROVED]: 'Not subscribed',
};

export const ADMIN_REVIEW_STATUS_LABELS: Record<string, string> = {
  [SUPERUSER_APPROVAL.ADMIN_APPROVED]: SUPERUSER_APPROVAL_LABEL[SUPERUSER_APPROVAL.ADMIN_APPROVED],
  [SUPERUSER_APPROVAL.AWAITING_APPROVAL]: 'In quality review',
  [SUPERUSER_APPROVAL.ADMIN_DISAPPROVED]: 'Waiting for supplier',
};

// A subscription state alone does not identify the quality-approved admin tab.
export const ADMIN_CATALOG_VIEWS: Record<string, { label: string; qualityStatus: string; subscriptionStatus: string | null }> = {
  IN_REVIEW: { label: ADMIN_REVIEW_STATUS_LABELS[SUPERUSER_APPROVAL.AWAITING_APPROVAL], qualityStatus: 'IN_REVIEW', subscriptionStatus: null },
  [PRODUCT_TABS.PENDING]: { label: ADMIN_SUBSCRIPTION_STATUS_LABELS[PRODUCT_TABS.PENDING], qualityStatus: SUPERUSER_APPROVAL.ADMIN_APPROVED, subscriptionStatus: PRODUCT_TABS.PENDING },
  [PRODUCT_TABS.APPROVED]: { label: ADMIN_SUBSCRIPTION_STATUS_LABELS[PRODUCT_TABS.APPROVED], qualityStatus: SUPERUSER_APPROVAL.ADMIN_APPROVED, subscriptionStatus: PRODUCT_TABS.APPROVED },
  [PRODUCT_TABS.DISAPPROVED]: { label: ADMIN_SUBSCRIPTION_STATUS_LABELS[PRODUCT_TABS.DISAPPROVED], qualityStatus: SUPERUSER_APPROVAL.ADMIN_APPROVED, subscriptionStatus: PRODUCT_TABS.DISAPPROVED },
};

export const PRODUCT_TAGSTATES = PRODUCT_TABS;

export const IS_FOOD_LOCAL_STORAGE_KEY = 'isFood';

export const isAdminCanUseAdminStatusFilter = (adminOrg: string | null) => {
  return ['apotea'].includes(adminOrg || '');
}

export const isAdminWithCombinedProductTypes = (adminOrg: string | null) => {
  return ['apotea', 'wolt'].includes(adminOrg || '');
};
